import React from 'react';
import { useTranslation } from 'react-i18next';

import LanguageSwitcher from './LanguageSwitcher/LanguageSwitcher';

import style from './Footer.module.scss';

const FooterLogo = (props) => {
    return (
        <svg {...props} width='22' height='19' viewBox='0 0 22 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12.941 0.294128C17.7302 0.294128 21.0219 2.39461 21.0219 6.42637C21.0219 9.85337 18.643 11.8854 14.9881 12.4182C14.3442 12.5118 13.66 12.5586 12.941 12.5586C9.49562 12.5586 6.82348 11.4715 5.59824 9.3584C6.46394 11.9088 8.83937 13.3632 12.5727 13.3632C13.29 13.3632 13.9759 13.3164 14.62 13.221C14.1627 15.0911 12.4226 16.369 9.96861 16.8262C10.0122 17.6901 10.1798 18.2877 10.5708 18.8204C9.43977 18.5487 7.84626 17.0133 7.84626 17.0133C3.73944 17.0133 0.918945 15.2117 0.918945 11.7559C0.918945 9.3764 2.39552 7.40911 4.86868 6.80795C4.86345 6.68195 4.96468 0.294128 12.941 0.294128ZM16.7833 12.2817C17.3546 12.2817 17.8478 12.6149 17.8478 13.3647C17.8478 14.128 17.3546 14.4613 16.7833 14.4613C16.2249 14.4613 15.7317 14.128 15.7317 13.3647C15.7317 12.6149 16.2249 12.2817 16.7833 12.2817ZM18.3737 14.4613C18.6592 14.4613 18.9058 14.628 18.9058 15.0027C18.9058 15.3844 18.6592 15.5511 18.3737 15.5511C18.0944 15.5511 17.8478 15.3844 17.8478 15.0027C17.8478 14.628 18.0944 14.4613 18.3737 14.4613Z'
                fill='url(#paint0_linear_2761_246)'
            />
            <defs>
                <linearGradient
                    id='paint0_linear_2761_246'
                    x1='0.918945'
                    y1='18.8204'
                    x2='21.0219'
                    y2='18.8204'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#6d62ef' />
                    <stop offset='1' stopColor='#9853F6' />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default function Footer() {
    const links = {
        'pages.footer.terms': 'https://vocalviews.com/terms-and-conditions/',
        'pages.footer.privacy': 'https://vocalviews.com/privacy-statement/',
        'pages.footer.contact': 'https://vocalviews.com/contact/',
        'pages.footer.support': 'https://support.vocalviews.com/',
    };
    const { t } = useTranslation();

    return (
        <footer className={style.footer}>
            <FooterLogo className={style.logo} />
            <span className={style.label}>© VocalViews, {new Date(Date.now()).getFullYear()}</span>
            <span className={style.links}>
                {Object.keys(links).map((link) => (
                    <a key={link} href={links[link]} target='_blank' rel='noreferrer'>
                        {t(link)}
                    </a>
                ))}
            </span>
            {/* <span className={style.networks}>
                <a href='https://www.facebook.com/VocalViews/' target='_blank'>
                    <FacebookIcon className={style.networkIcon} />
                </a>
                <a href='https://www.linkedin.com/company/vocal-views-ltd' target='_blank'>
                    <LinkedInIcon className={style.networkIcon} />
                </a>
                <a href='https://twitter.com/vocalviews' target='_blank'>
                    <TwitterIcon className={style.networkIcon} />
                </a>
            </span> */}
            <LanguageSwitcher iconClassName={style.previewIcon} withIcon={true} previewClassName={style.preview} />
        </footer>
    );
}
